import { nextTick, reactive, ref, toRefs } from 'vue'
import Schema from 'async-validator'
import { Message } from 'view-design'
import { clone } from '@/common/js/just.js'
import { getProjectFormModel } from '../model/form.js'
import { getProjectFormRules } from '../rules/index.js'

/**
 * @description: 项目基础信息配置表单
 * @return {*}
 */
export function useProjectConfigForm(configForm) {
  const formRef = ref(null)

  const showBasicModal = ref(false)

  const methods = {
    /**
     * @description: 关闭抽屉弹窗表单前的校验
     * @return {*}
     */
    formValidator: (done) => {
      formRef.value
        .validate()
        .then(done)
        .catch((e) => {
          const errorElement = document.querySelector('.project-form .el-form-item__error')
          errorElement?.scrollIntoView({ block: 'center', behavior: 'smooth' })
          console.log('validate error output: ', e)
        })
    },
    /**
     * @description: 供父组件调用
     * @return {*}
     */
    async validate() {
      const descriptor = getProjectFormRules.call(configForm.value.project)
      const validator = new Schema(descriptor)
      try {
        await validator.validate(configForm.value.project)
        return Promise.resolve()
      } catch ({ errors, fields }) {
        console.log('errors output: ', errors)
        console.log('fields output: ', fields)

        return Promise.reject(new Error(0))
      }
    },

    getFormFileds: () => formRef.value.getForm(),
    setFormFileds: (form) => formRef.value.setForm(form),

    /**
     * @description: 打开弹窗，如果是编辑模式，将表单数据填充
     */
    onShowConfigModal: () => {
      if (!configForm.value.accounts?.length) {
        return Message.warning('请先添加账号')
      }
      showBasicModal.value = true
      // 如果已存在配置信息，直接覆盖
      const { project } = configForm.value
      nextTick(() => {
        // 避免数据引用导致修改配置还未确认之前预览数据也被修改，克隆一份表单内容进行再次修改
        const form = project?.project_name ? clone(project) : getProjectFormModel({ isV3: configForm.value.isV3 })
        formRef.value.setForm(form)
      })
    }
  }

  return { formRef, showBasicModal, methods }
}

/**
 * @description: 选择搜索快投
 * @return {*}
 */
export function useSearchBid(configForm, updateConfigForm) {
  const searchBid = reactive({
    showSearchBidKeywordModal: false,
    searchBidKeywordList: [],
    accountId: ''
  })

  function onSearchKeywordAdd() {
    searchBid.showSearchBidKeywordModal = true
    searchBid.accountId = configForm.value.accounts[0].id
  }

  /**
   * @description: 处理搜索快投选择逻辑
   * @param {*} keywords
   */
  function onSearchKeywordSelectConfirm(keywords) {
    const projectForm = configForm.value.project
    const form = {
      ...projectForm,
      keywords: keywords.map((item) => ({
        word: item.keyword,
        bid_type: 'FEED_TO_SEARCH',
        match_type: item.patern.value
      })),
      keywordsDesc: ''
    }

    searchBid.searchBidKeywordList = keywords

    const len = keywords.length
    if (len) {
      const [firstItem] = keywords
      form.keywordsDesc = `已选${firstItem.keyword}...共${len}个关键词`
    } else {
      form.keywordsDesc = '未添加关键词，待自动更新'
    }

    updateConfigForm({
      ...configForm.value,
      project: { ...form }
    })
  }

  return {
    ...toRefs(searchBid),
    onSearchKeywordAdd,
    onSearchKeywordSelectConfirm
  }
}
